import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";

import Home from "./HomePage";
import About from "./pages/About";
//import Contact from "./pages/Contact";
import Test from "./pages/Test";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import VerifyOTP from "./pages/VerifyOTP";
import QuestionExtraction from "./pages/QuestionExtraction";
import SupportUs from "./pages/SupportUs";
import DecksPage from "./pages/DecksPage";
import TextCard from "./components/Flashcards/TextCard";
import CreateTest from "./pages/Createpublictest";
import MyTests from "./pages/MyTest";
import AttemptTest from "./pages/AttemptTest";
import TestTypePage from "./pages/Tests/TestTypePage";
import TestPlay from "./pages/Tests/TestPlay";
import PublicTests from "./pages/PublicTests";
import ProctoredTests from "./pages/Tests/ProctoredTests";
import EditTest from "./pages/EditTest";
import CreateFlashcards from "./pages/CreateFlashcards";
import TestResult from "./pages/TestResult";
import GameSelectTest from "./pages/Game/GameSelectTest";
import GamePlay from "./pages/Game/GamePlay";
import GameResult from "./pages/Game/GameResult";
import UserActivityDashboard from "./pages/UserActivityDashboard";

import Navbar from "./components/Navbar";
import FloatingBottomNavbar from "./components/FloatingBottomNavbar";
import MobileTopBar from "./components/MobileTopBar";
import MathDrillsHome from "./pages/MathDrills/MathDrillsHome";
import ChainMath from "./pages/MathDrills/ChainMath";
import MentalMath from "./pages/MathDrills/MentalMath";
//import NewFocusGame from "./pages/FocusGame/FocusGame";


import PracticePlayTest from "./pages/newTesttypes/PracticePlayTest";
import TimedPlayTest from "./pages/newTesttypes/TimedPlayTest";
import TimedSettings from "./pages/newTesttypes/TimedSettings";

import Groups from "./pages/Groups";
import GroupDetails from "./pages/GroupDetails";
import CreateGroup from "./pages/CreateGroup";
//import NewMemoryGame from "./pages/memogame/memorygame";
import CarGame from "./pages/memogame/cargame";
import AirStrikeGame from "./games/AirStrike/AirStrikeGame";
import ObservationGame from "./components/ObservationGame";
//import MemoryGame from "./components/MemoryGame";

//import FocusGame from "./components/FocusGame";
// OLD GAMES
import OldMemoryGame from "./pages/memogame/memorygame";
import OldFocusGame from "./pages/FocusGame/FocusGame";

// NEW WHITE ROOM GAMES
import MemoryGameV2 from "./components/MemoryGame";
import FocusGameV2 from "./components/FocusGame";

function App() {
  const [userName, setUserName] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const storedUserName = localStorage.getItem("userName");
    if (storedUserName) setUserName(storedUserName);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    setUserName(null);
    window.location.href = "/";
  };

  return (
    <Router>
      {/* 🔹 Desktop: top navbar */}
      <div className="hidden md:block">
        <Navbar
          userName={userName}
          handleLogout={handleLogout}
          menuOpen={menuOpen}
          setMenuOpen={setMenuOpen}
        />
      </div>
     {/* 📱 Mobile top bar */}
<MobileTopBar userName={userName} onLogout={handleLogout} />

      {/* 🔹 Mobile: floating bottom navbar */}
      <div className="md:hidden">
        <FloatingBottomNavbar />
      </div>

      {/* 🔹 Main content */}
      <div className="font-sans bg-[#FAF6EF] min-h-screen pt-16 pb-32">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          {/*<Route path="/contact" element={<Contact />} />*/}
          <Route path="/test" element={<Test />} />

          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/verify" element={<VerifyOTP />} />
          <Route path="/support" element={<SupportUs />} />
         
          <Route path="/question-extraction" element={<QuestionExtraction />} />
          <Route path="/flashcards" element={<DecksPage />} />
          <Route path="/flashcards/:deckId" element={<TextCard />} />
          <Route path="/public-tests" element={<PublicTests />} />
          <Route path="/edit-test/:id" element={<EditTest />} />
          <Route path="/math-drills" element={<MathDrillsHome/>}/>
          <Route path="/math-drills/chain-math" element={<ChainMath/>}/>
          
          <Route path="/math-drills/mental-math" element={<MentalMath/>}/>

          
          
          <Route path="/groups" element={<Groups />} />
<Route path="/groups/create" element={<CreateGroup />} />
<Route path="/groups/create/:parentId" element={<CreateGroup />} />
<Route path="/groups/:id" element={<GroupDetails />} />

          
          
          <Route
            path="/createtest"
            element={
              localStorage.getItem("token") ? (
                <CreateTest />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />

          <Route path="/create-flashcards" element={<CreateFlashcards />} />
          <Route path="/mytests" element={<MyTests />} />
          <Route path="/test/:type/:id" element={<AttemptTest />} />
          <Route path="/tests/:type/:id" element={<TestPlay />} />
          <Route path="/tests/:type" element={<TestTypePage />} />
          <Route path="/result/:id" element={<TestResult />} />
          <Route path="/tests/proctored" element={<ProctoredTests />} />
          <Route path="/practice/:id" element={<PracticePlayTest />} />
          <Route path="/timed/:id" element={<TimedPlayTest/>}/>
          <Route path="/timed-settings/:id" element={<TimedSettings />} />
          
          
  

          <Route path="/game" element={<GameSelectTest />} />
          <Route path="/game/play/:testId" element={<GamePlay />} />
          <Route path="/game/result" element={<GameResult />} />
      
          <Route path="/car-game" element={<CarGame />} />
          <Route path="/airstrike" element={<AirStrikeGame />} />
          <Route path="/observation-game" element={<ObservationGame />} />
          {/* OLD */}
<Route path="/memory-game" element={<OldMemoryGame />} />
<Route path="/focus-game" element={<OldFocusGame />} />

{/* NEW */}
<Route path="/memory-game-v2" element={<MemoryGameV2 />} />
<Route path="/focus-game-v2" element={<FocusGameV2 />} />
          <Route
            path="/activity"
            element={
              localStorage.getItem("token") ? (
                <UserActivityDashboard />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
